import { render, staticRenderFns } from "./init-clock.vue?vue&type=template&id=5193d844&scoped=true&"
import script from "./init-clock.vue?vue&type=script&lang=js&"
export * from "./init-clock.vue?vue&type=script&lang=js&"
import style0 from "./init-clock.vue?vue&type=style&index=0&id=5193d844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5193d844",
  null
  
)

export default component.exports